import { SET_ACCESS_TOKEN, RESET_TOKEN } from "./AccountActionTypes";

const mutations = {
	[SET_ACCESS_TOKEN]: (state, token) =>
	{
		state.token = token;
	},
	[RESET_TOKEN]: (state) =>
	{
		state.token = "";
	},
};

export default { mutations };
